import React, { useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { getLanguage } from '..';

export const TextVideoBlock = () => {
    const content = {
        title: {
            en: `Reprocess and Repurpose`,
            sp: `Reprocesar y Dar un nuevo propósito`,
            pt: `Reprocessar e Reaproveitar`
        },
        description: {
            en: `<p>After the green coffee is emptied from our HERMÉTICA™ bags, they can be recycled via the PONO Program. Savor Brands R+R™ Boxes are complimentary to everyone in the Savor Brands ecosystem. These boxes collect used bags for reprocess and repurpose. If the roaster you work with doesn’t have a box, let us know and under your direction, we will send them one as a courtesy to you, free of charge. This allows us to work PONO (Hawaiian for do what is right) and close the loop on the packaging we create.</p>`,
            sp: `<p>Después de utilizar el café verde de nuestras bolsas herméticas, se pueden reciclar a través de nuestro programa PONO. Las cajas Savor Brands R + R ™ son complementarias para todos nuestros clientes en el ecosistema Savor Brands. Estas cajas recogen bolsas usadas para ser reprocesadas y reutilizadas. Si el tostador con el que trabaja no tiene una caja, infórmenos y enviaremos como cortesía una caja a su nombre (sin cargo extra). Esto nos permite trabajar PONO (En Hawaiano: hacer lo que es correcto) y así cerrar el ciclo en el empaque que creamos.</p>`,
            pt: `<p>Depois que o café verde é esvaziado de nossas sacolas (embalagems) HERMÉTICA ™, elas podem ser recicladas através do Programa PONO. As caixas Savor Brands R + RTM são gratuitas para todos no ecossistema Savor Brands. Essas caixas coletam as embalagems usadas para reprocessar e reutilizar. Se o torrador com o qual você trabalha não tiver uma caixa, informe-nos e, sob sua direção, enviaremos uma como cortesia para você, gratuitamente. Isso nos permite trabalhar PONO (havaiano para fazer o que é certo) e fechar o ciclo na embalagem que criamos.</p>`
        }
    };

    const language = getLanguage();

    // Create a ref and apply useInView
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '0px 0px -100px 0px' }); // Start animation 100px before it enters the viewport

    // Define fade-in animation variants with stagger effect
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3, delayChildren: 0.2 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <AnimatePresence>
            <motion.div 
                id='textVideoBlock'
                ref={ref}
                className='relative py-20 px-32'
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={containerVariants}
            >
                <motion.h2 
                    className='text-3xl' 
                    dangerouslySetInnerHTML={{ __html: content.title[language] }} 
                    variants={itemVariants}
                />
                <motion.div className='border-lime-green left' variants={itemVariants}>
                    <motion.video className='w-large' controls variants={itemVariants}>
                        <source src='https://videos.ctfassets.net/vhts96p7twn6/okWTrSEnTBmEZtaLFjDSw/380049e8d9f892c453854abbd7ea18ce/1557273551.mp4' type="video/mp4" />
                        <track src="captions_en.vtt" kind="captions" srcLang="en" label="English Captions"></track>
                    </motion.video>
                </motion.div>
                <motion.div 
                    className='py-15' 
                    dangerouslySetInnerHTML={{ __html: content.description[language] }} 
                    variants={itemVariants}
                />
            </motion.div>
        </AnimatePresence>
    );
}